import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import { APayOnBehalfOf } from 'kuaidong-api'
import { PopupPoster } from 'kuaidong-component'
import { IPayOnBehalfOfInfo } from 'kuaidong-model'
import { UIUtil, VueUtil, AppUtil, CanvasPoster, RouterUtil } from 'kuaidong-lib'

import IconLogo from '../images/icon_logo@2x.png'

import PayOnBehalfOfPoster from './PayOnBehalfOfPoster.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayOnBehalfOfPosterPopup',
  props: {
    sku: null,
    bgImg: null
  },
  setup(__props: any) {

const props = __props as { sku: string; bgImg?: string };



const info = ref<IPayOnBehalfOfInfo | null>(null)

const qrcodeUrl = ref('')

const isUnderApp = ref(false)

onMounted(async () => {
  isUnderApp.value = await AppUtil.isUnderApp()

  fetch()
})

async function fetch() {
  try {
    info.value = await APayOnBehalfOf.create(props.sku)

    qrcodeUrl.value = await CanvasPoster.createQRCodeImageURL(
      RouterUtil.buildUrlFromRoute({ path: '/splus/pay-on-behalf-of' }, { id: info.value.share_pay_id }),
      VueUtil.getActualPx(80 * window.devicePixelRatio),
      IconLogo,
      VueUtil.getActualPx(16 * window.devicePixelRatio)
    )
  } catch (e) {
    e.text && UIUtil.showToast(e.text)
  }
}

return { __sfc: true,props, info, qrcodeUrl, isUnderApp, fetch, PopupPoster, PayOnBehalfOfPoster }
}

})